import React, { useContext } from "react";

import { ItemCardStyled } from "./catalogue.styles";
import { BigItemIcon } from "../../../../../AuthenticatedApp/components/productCatalogue/common/images/Icons";
import { capitalize, formatKoboBalance } from "../../../../../../utils/utilityFunctions";
import { ActionTypes, ChargeItemsContext } from "../../context";

const ItemCard = ({ item, handleCreateOrder }) => {
    const { state, contextDispatch } = useContext(ChargeItemsContext);

    const handleSelectItem = () => {
        contextDispatch({
            type: ActionTypes.ADD_ITEM,
            payload: {
                price: item.unitPrice,
                name: item.name,
                id: item.id,
            },
        });
        if (state.itemsState.length < 1 && state.orderNumber === "") {
            handleCreateOrder(item);
        }
    };
    return (
        <ItemCardStyled
            onClick={handleSelectItem}
            selectedStyle={state.itemsState?.find((itemSt) => itemSt.id === item.id)}
        >
            <div>
                <BigItemIcon />
            </div>
            <div className="catalogue__content-wrap">
                <div>
                    <h4>{capitalize(item.name)}</h4>
                    <p>{formatKoboBalance(item?.unitPrice)}</p>
                </div>
            </div>
        </ItemCardStyled>
    );
};

export default ItemCard;
